



















































































import { Prop, Component } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { SwIcon } from '../sw-icon';
import { StatusName, CSSStyleOptions } from '../common-types';
import { utilService } from '../util-service';

/**
 * @event close `(event: MouseEvent)`
 */
@Component({
  components: {
    SwIcon,
  },
})
export default class SwStatusInfo extends SwExtendedVue {
  @Prop({ type: [String, Array], default: 'This is an informational message' })
  message: string | string[];

  @Prop({ type: String, default: 'informational' }) name: StatusName;

  @Prop({ type: [String, Boolean], default: true })
  withTitle: boolean | string;

  @Prop({ type: Boolean, default: true })
  closable: boolean;

  get iconName() {
    return utilService.statusInfoMap[this.name].icon;
  }
  get iconColor() {
    return utilService.statusInfoMap[this.name].textColor;
  }

  get iconRotate() {
    if (this.name === 'up') { return 90; }
    if (this.name === 'down') { return -90; }
    return undefined;
  }

  get title() {
    if (this.withTitle === true) {
      return this.$t(utilService.statusInfoMap[this.name].textI18nPath)
        .toString();
    }
    if (!this.withTitle) {
      return null;
    }
    return String(this.withTitle);
  }

  get messageArray(): string[] {
    if (Array.isArray(this.message)) { return this.message; }
    return [this.message];
  }

  get rootStyle(): CSSStyleOptions {
    const style: CSSStyleOptions = {
      backgroundColor: utilService.statusInfoMap[this.name].color,
    };
    return style;
  }
  get textColor(): CSSStyleOptions {
    const style: CSSStyleOptions = {
      color: utilService.statusInfoMap[this.name].textColor,
    };
    return style;
  }

  private hasComplexMessage(): boolean {
    const slot = utilService.getVueScopedSlot(this.$scopedSlots);
    return slot.length > 0;
  }

  private onClickClose(event: MouseEvent) {
    this.$emit('close', event);
  }
}
